var SENTRY_RELEASE;SENTRY_RELEASE={name: "PropSwap-main", version: "2.9.5"};